import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import logoSisdafNegativo from '../assets/logo_sisaf_negativo.png';

const Wrapper = styled.div`
  background-color: #c5d4eb;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

const Card = styled.div`
  background-color: #ffffff;
  border-radius: 30px;
  max-width: 600px;
  width: 100%;
  overflow: hidden;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  font-family: Arial, Helvetica, sans-serif;
`;

const Header = styled.div`
  background-color: #1351b4;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  width: 150px;
`;

const Content = styled.div`
  padding: 60px 40px;
  text-align: center;
`;

const Title = styled.h1`
  color: #1351b4;
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 20px;
`;

const Text = styled.p`
  font-size: 18px;
  color: #333;
  line-height: 26px;
  margin-bottom: 40px;
`;

const Button = styled.button`
  background-color: #ffa800;
  color: #fff;
  font-size: 16px;
  padding: 12px 32px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: bold;
  text-transform: uppercase;
`;

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Card>
        <Header>
          <Logo src={logoSisdafNegativo} alt="Logo SisDAF" />
        </Header>
        <Content>
          <Title>Acesso Negado</Title>
          <Text>
            Você não tem permissão para acessar esta página.
            <br />
            Entre em contato com o administrador do sistema para obter
            permissão.
          </Text>
          <Button onClick={() => navigate(-1)}>Voltar</Button>
        </Content>
      </Card>
    </Wrapper>
  );
};

export default AccessDenied;
